import React from "react";

const Button = (props) => {
  const {
    text,
    background,
    opacity,
    title,
    height,
    width,
    borderColor,
    borderHover,
    customFunc,
    isDisabled,
  } = props;

  return (
    <button
      type="button"
      className={`text-xl rounded-xl mx-2 ${text} ${height} ${width}
      ${
        isDisabled
          ? "bg-gray-400"
          : `${background} ${opacity} ${borderHover} 
            ${borderColor || `border-snappily-orange`}
            border-spacing-0 border-2 focus:outline-none sm:focus:ring
            focus:ring-gray-400 sm:hover:bg-opacity-60 sm:hover:text-black 
            hover:border-2 sm:active:bg-gray-700`
      }`}
      onClick={customFunc}
      disabled={isDisabled}
    >
      {title}
    </button>
  );
};

export default Button;
